import script from "./TheMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheMenu.vue?vue&type=script&setup=true&lang=ts"

import "./TheMenu.vue?vue&type=style&index=0&id=13670a24&lang=scss"

const __exports__ = script;

export default __exports__